<div class="modal-dialog edit-user-dialog-container">
	<div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
		<div class="goreact-modal-header">
			<h4 class="modal-title">
				<span translate="modal-edit-user_title"
					[translateParams]="{name: fullname}"
					[id]="dialogTitleId"
					class="username"></span>
			</h4>
			<button
				class="close-btn"
				type="button"
				[attr.aria-label]="'common_close' | translate"
				(click)="close()">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<!-- User info form -->
			<div class="container-fluid">
				<div class="row">
					<div class="user-info col-md-6">
						<section class="user-info-section">
							<div class="row form-group">
								<!-- First Name -->
								<div class="col-md-6">
									<mat-label translate="modal-edit-user_first-name"></mat-label>
									<div class="input-group">
										<span>{{data.user.first_name}}</span>
									</div>
								</div>
								<!-- Last Name -->
								<div class="col-md-6">
									<mat-label translate="modal-edit-user_last-name"></mat-label>
									<div class="input-group">
										<span>{{data.user.last_name}}</span>
									</div>
								</div>
							</div>
							@if (userService.currentUser.is_root_user) {
								<div class="row form-group">
									<!-- Billing Entity ID -->
									<div class="col-md-6">
										<mat-label translate="modal-edit-user_billing-entity"></mat-label>
										<div class="input-group">
											<span>{{(data.user.billing_entity_id &gt; 0) ? data.user.billing_entity_id : 'None'}}</span>
										</div>
									</div>
									<!-- User ID -->
									<div class="col-md-6">
										<mat-label translate="modal-edit-user_user"></mat-label>
										<div class="input-group">
											<span>{{data.user.user_id}}</span>
										</div>
									</div>
								</div>
							}
							<!-- Email -->
							<div class="form-group">
								<mat-label translate="modal-edit-user_email-colon"></mat-label>
								<div class="input-group">
									<span>{{data.user.email}}</span>
								</div>
							</div>
							<!-- SSO Providers -->
							@if (userService.currentUser.is_root_user && ssoProviders$ | async) {
								<div class="row form-group sso-section">
									<div class="col-md-6">
										<label translate="modal-edit-user_sso"></label>
										<div class="input-group">
											<span>{{ssoProviders$ | async}}</span>
										</div>
									</div>
								</div>
							}
						</section>
						@if (userService.currentUser.is_root_user) {
							<section class="credits">
								@for (credit of credits$ | async; track credit) {
									<h4 translate="modal-edit-user_user-credits" [translateParams]="{available: credit.units_available, max: credit.max_video_mins}"></h4>
								}
								@if (data.user.billing_entity_id) {
									<a class="tertiary-btn offset-md-2" aria-label="view credit ledger" [href]="adminToolsUrl + '/#/global/reports/credit-ledger?beid=' + data.user.billing_entity_id" target="_blank" translate="modal-edit-user_view-credit"></a>
								}
							</section>
						}
						@if (userService.currentUser.is_root_user && (linkedUsers$ | async)?.length) {
							<section class="linked-accounts">
								<h4 translate="modal-edit-user_linked-accounts"></h4>
								<div class="col-md-12">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th translate="modal-edit-user_user-id"></th>
												<th translate="modal-edit-user_name"></th>
												<th translate="common_email"></th>
												<th translate="modal-edit-user_actions"></th>
											</tr>
										</thead>
										<tbody>
											@for (user of linkedUsers$ | async | sort:'last_name'; track user.user_id) {
												<tr>
													<td>{{user.user_id}}</td>
													<td class="linked-user-fullname">{{user.fullname}}</td>
													<td class="fullstory-ignore linked-user-email">{{user.email}}</td>
													<td>
														<a
															class="btn btn-none btn-sm"
															[title]="'modal-edit-user_login-as' | translate:{name: user.fullname}"
															(click)="maskAs(user)">
															<i class="ficon-app-mask"></i>
														</a>
														<button
															(click)="editUser(user)"
															type="button"
															class="btn btn-none btn-rnd"
															[title]="'modal-edit-user_edit-user' | translate">
															<i class="ficon-app-edit"></i>
														</button>
													</td>
												</tr>
											}
										</tbody>
									</table>
								</div>
							</section>
						}
					</div>
					<!-- User roles form -->
					<form class="user-roles form-horizontal col-md-6">
						<div>
							@if (!(role === 'owner' || !data.group)) {
								<div class="row form-group user-role-dropdown">
									<span class="permission-dropdown">
										<label class="goreact-label dropdown-label">
											<span translate="modal-edit-user_permission" [translateParams]="{name: data.group.name}"></span>
											<a class="ficon-help" aria-label="user permission help" [href]="helpUrls.userPermsHelp" [target]="helpUrls.target"></a>
										</label>
										<!-- User role select -->
										<span class="go-select-group">
										<select
											class="capitalize form-control go-select"
											name="userRole"
											[(ngModel)]="role"
											[disabled]="userService.currentUser.user_id === data.user.user_id"
											(change)="updateUserRole(data.user, data.group, role)">
												@for (role of roles; track role.role) {
													<option [value]="role.role">{{role.roleKey | translate}}</option>
												}
											</select>
										</span>
									</span>
								</div>
							}
							<div class="form-group">
								<table id="user-permissions-table" class="table table-bordered">
									<caption class="table-caption" translate="modal-edit-user_permissions-for-user"></caption>
									<thead>
										<tr>
											<th translate="modal-edit-user_name"></th>
											<th translate="modal-edit-user_type"></th>
											<th translate="modal-edit-user_role"></th>
										</tr>
									</thead>
									<tbody>
										@for (group of groups$ | async | sort:'type'; track group) {
											<tr>
												<td>
													<!-- Unpaid badge (presenter hasn't paid for group) -->
													@if (userService.currentUser.is_root_user && showHasNotPaid(group)) {
														<span class="badge badge-red"
															[title]="'group-settings_not-yet-paid' | translate: {name: fullname, type: (group.type_localized | translate)}"
															style="font-size: 12px;">
															<strong>$</strong>
														</span>
													}
													<!-- Paid badge (presenter has paid for group) -->
													@if (userService.currentUser.is_root_user && showHasPaid(group)) {
														<span class="badge badge-grey"
															[title]="'group-settings_has-paid' | translate: {name: fullname, type: (group.type_localized | translate)}"
															style="font-size: 12px;">
															<strong>$</strong>
														</span>
													}&nbsp;
													<a
														href
														[attr.aria-label]="group.name"
														[ngClass]="{italic: group.future, grey: group.past}"
														(click)="close(group)">
														{{group.name}}
													</a>
												</td>
												<td>{{group.type_localized | translate}}</td>
												<td class="capitalize">
													<span class="label role-{{group.role}}">
														{{group.role_localized | translate}}
													</span>
												</td>
											</tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</form>
				</div>
			</div>
			@if (userService.currentUser.is_root_user) {
				<div class="container-fluid">
					<h4 translate="modal-edit-user_recent-logins"></h4>
					<table class="table table-bordered" id="recent-logins-table">
						<thead>
							<tr>
								<th translate="modal-edit-user_last-accessed"></th>
								<th translate="modal-edit-user_ip-address"></th>
								<th translate="modal-edit-user_browser"></th>
								<th translate="modal-edit-user_platform"></th>
								<th translate="modal-edit-user_device"></th>
							</tr>
						</thead>
						<tbody>
							@for (login of recentLogins$ | async; track login) {
								@let ua = (parseUa(login.agent));
								<tr>
									<td class="recent-login-date">{{login.created_at | formatDate:'MMM d, YYYY h:mm a'}}</td>
									<td>{{login.ip}}</td>
									<td>
										<span [title]="ua.browser.name + ' ' + ua.browser.version + ' / ' + ua.engine.name + ' ' + ua.engine.version">{{ua.browser.name}} {{ua.browser.version}}</span>
									</td>
									<td>{{ua.os.name}} {{ua.os.version}}
										@if (ua.cpu.architecture) {
											<span>[{{ua.cpu.architecture}}]</span>
										}
									</td>
									<td>{{ua.device.vendor}} {{ua.device.model}}</td>
								</tr>
							}
						</tbody>
					</table>
					<div class="form-group">
						@if (userService.currentUser.is_root_user) {
							<button type="button" aria-label="activity history" class="secondary-btn" (click)="activityHistory()" translate="modal-edit-user_device-activity"></button>
						}
					</div>
				</div>
			}
		</div>

		<div class="goreact-modal-footer">
			<button
				class="primary-btn close-btn"
				[attr.aria-label]="'common_close' | translate"
				type="button"
				(click)="close()"
				data-cy="edit-user-close"
				translate="common_close">
			</button>
		</div>
	</div>
</div>
